import { useAtomValue, useSetAtom } from 'jotai';
import { useParams } from 'react-router-dom';

import { useGetClientUserPaperwork as useSeedlingGetClientUserPaperwork } from '@grow-therapy-team/seedling-components';

import { clientUserShortIdAtom } from '../../state';
import { useGetPublicPatient } from '../../useGetPublicPatientByShortId';
import { visitorMeasuresAtom } from '../state';

export function useGetClientUserPaperwork() {
  const appointmentClientUserShortId = useAtomValue(clientUserShortIdAtom);
  const { patientShortId, providerShortId } = useParams() as { patientShortId: string; providerShortId: string };

  // client user short ID is required to look up measures, but when we don't have a connection between the patient and client user id when there is not an associated appointment
  const { data: publicPatientData } = useGetPublicPatient(appointmentClientUserShortId ? undefined : patientShortId);
  const clientUserShortId = (appointmentClientUserShortId || publicPatientData?.publicPatient?.clientUserShortId) ?? '';

  const setVisitorMeasures = useSetAtom(visitorMeasuresAtom);

  return useSeedlingGetClientUserPaperwork(clientUserShortId, providerShortId, {
    onCompleted(data) {
      setVisitorMeasures(data.outstandingMeasures || []);
    },
    // While not strictly required, omitting the provider short ID will return
    // *all* measures, rather than just the ones for a specific patient-provider
    // relationship.
    skip: !providerShortId,
  });
}
